import { useEffect, useState } from 'react';

import { Text } from '@spotify-internal/encore-web';

export const ElapsedTimer = ({ startedAt }: { startedAt: number }) => {
  const [elapsedSeconds, setElapsedSeconds] = useState(() =>
    Math.floor((Date.now() - startedAt) / 1000),
  );

  useEffect(() => {
    const tick = () =>
      setElapsedSeconds(Math.floor((Date.now() - startedAt) / 1000));
    tick();
    const interval = window.setInterval(tick, 1000);
    return () => window.clearInterval(interval);
  }, [startedAt]);

  if (elapsedSeconds < 1) return null;

  return (
    <Text as="span" variant="bodySmall" semanticColor="textSubdued">
      {elapsedSeconds}s
    </Text>
  );
};
